import { render, staticRenderFns } from "./salesExWarehouseRecord.vue?vue&type=template&id=cbfc314a"
import script from "./salesExWarehouseRecord.vue?vue&type=script&lang=js"
export * from "./salesExWarehouseRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports